import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LetterProcessingPage from "./LetterProcessingPage";

const LetterProcessingRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<LetterProcessingPage />} />
      <Route path="*" element={<Navigate to="/letter-processing" replace />} />
    </Routes>
  );
};

export default LetterProcessingRoutes;
